module.exports = __webpack_public_path__ + "8a5356e9/img/upload-icon.9179ae4e.svg";